import angular from 'angular';
import { MsalAuthService } from './MsalAuthService';

angular.module('sh.msalAuth', ['sh.identity']).service('MsalAuth', MsalAuthService);
